import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "intro-form" }
const _hoisted_2 = {
  key: 0,
  class: "ai-welcome"
}
const _hoisted_3 = { class: "form-title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "theme-info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "char-counter" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { ref, computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'IntroductionForm',
  emits: ["submitDescription"],
  setup(__props, { emit: __emit }) {

const gameStore = useGameStore();
const description = ref('');

const welcomeNarration = computed(() => {
    const narration = gameStore.room?.active_narration;
    if (narration && narration.type === 'game_start_narration') {
        return {
            title: narration.title || 'Начало игры',
            narration: narration.narration?.replace(/{{{(.*?)}}}/g, '<strong>$1</strong>') || ''
        }
    }
    return null;
});

const emit = __emit;
const submit = () => { emit('submitDescription', description.value); };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (welcomeNarration.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(welcomeNarration.value.title), 1),
          _createElementVNode("p", {
            class: "form-subtitle",
            innerHTML: welcomeNarration.value.narration
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "action-prompt" }, [
      _createElementVNode("h3", { class: "form-title-secondary" }, "Теперь ваша очередь"),
      _createElementVNode("p", { class: "form-subtitle" }, "Расскажите о своем персонаже, чтобы ведущий мог вплести вашу историю в игру.")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      (_unref(gameStore).room?.environ)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _cache[1] || (_cache[1] = _createTextVNode(" Тема игры: ")),
            _createElementVNode("strong", null, "\"" + _toDisplayString(_unref(gameStore).room.environ) + "\"", 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, " Тема игры не задана. Можете придумать любую историю. "))
    ]),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
      class: "form-input",
      rows: "4",
      maxlength: "300",
      placeholder: "Например: 'Я старый алкаш, который видел в этом городе всё...'"
    }, null, 512), [
      [_vModelText, description.value]
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(description.value.length) + " / 300", 1),
    _createElementVNode("button", {
      onClick: submit,
      class: "btn"
    }, [
      (description.value.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Пропустить описание"))
        : (_openBlock(), _createElementBlock("span", _hoisted_10, "Отправить"))
    ])
  ]))
}
}

})